interface Manifest {
  version: string
  entrypoint: string
  css?: string
}

let manifestCache: Manifest | null = null

/**
 * Load micro-frontend via manifest.json
 * Note: Vite dev server (HMR) cannot be loaded cross-origin due to React Refresh preamble issues.
 * Always use a built version (npm run build) for integration with Gatsby.
 */
export const loadMicroFrontend = async (baseUrl: string): Promise<void> => {
  try {
    console.log('🚀 Loading micro-frontend from:', baseUrl)
    
    // Fetch manifest if not cached
    if (!manifestCache) {
      const manifestUrl = `${baseUrl}/manifest.json`
      const response = await fetch(manifestUrl, {
        cache: 'no-cache' // Always get latest version
      })
      
      if (!response.ok) {
        throw new Error(`Failed to fetch manifest: ${response.status}`)
      }
      
      manifestCache = await response.json()
      console.log('📦 Manifest loaded:', manifestCache)
    }
    
    // Load CSS if specified
    if (manifestCache.css && !document.querySelector(`link[href="${manifestCache.css}"]`)) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = manifestCache.css
      document.head.appendChild(link)
      console.log('🎨 CSS loaded:', manifestCache.css)
    }
    
    // Load JavaScript
    if (!document.querySelector(`script[src="${manifestCache.entrypoint}"]`)) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = manifestCache!.entrypoint
        script.async = true
        script.onload = () => {
          console.log('✅ Micro-frontend script loaded')
          resolve()
        }
        script.onerror = () => reject(new Error('Failed to load micro-frontend script'))
        document.body.appendChild(script)
      })
    }
  } catch (error) {
    console.error('❌ Error loading micro-frontend:', error)
    throw error
  }
}

export const clearManifestCache = () => {
  manifestCache = null
}

